import { render, staticRenderFns } from "./BusinessFooter.vue?vue&type=template&id=0203ea2b&"
import script from "./BusinessFooter.vue?vue&type=script&lang=js&"
export * from "./BusinessFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0203ea2b')) {
      api.createRecord('0203ea2b', component.options)
    } else {
      api.reload('0203ea2b', component.options)
    }
    module.hot.accept("./BusinessFooter.vue?vue&type=template&id=0203ea2b&", function () {
      api.rerender('0203ea2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BusinessFooter.vue"
export default component.exports